export const SETUP_GAME_SETTINGS = "SETUP_GAME_SETTINGS";

export const UPDATE_PLAYERS_BIDS = "UPDATE_PLAYERS_BIDS";

export const RESET_PLAYER_BIDS = "RESET_PLAYER_BIDS";

export const SUBMIT_WINNING_BID = "SUBMIT_WINNING_BID";
export const RESET_WINNING_BID = "RESET_WINNING_BID";

export const SET_TRUMP_SUIT = "SET_TRUMP_SUIT";

export const SET_CURRENT_TURN = "SET_CURRENT_TURN";

export const UPDATE_CURRENT_TRICK = "UPDATE_CURRENT_TRICK";

export const SET_TRICK_LEADER = "SET_TRICK_LEADER";

export const SET_TRICK_SUIT = "SET_TRICK_SUIT";

export const RESET_CURRENT_TRICK = "RESET_CURRENT_TRICK";

export const AWARD_TRICK_TO_WINNER = "AWARD_TRICK_TO_WINNER";

// Cutthroat-only counterparts to AWARD_TRICK_TO_WINNER/UPDATE_SCORE - award
// tricks to (and score) an individual player instead of a team. Added
// alongside the team actions rather than replacing them so 2v2 Teams keeps
// using its existing action types untouched.
export const AWARD_TRICK_TO_PLAYER = "AWARD_TRICK_TO_PLAYER";
export const UPDATE_INDIVIDUAL_SCORES = "UPDATE_INDIVIDUAL_SCORES";

export const RESET_TRICK_SUIT = "RESET_TRICK_SUIT";

export const UPDATE_SCORE = "UPDATE_SCORE";

export const RESET_BIDDING_ROUND = "RESET_BIDDING_ROUND";

export const RESET_CURRENT_TURN = "RESET_CURRENT_TURN";

export const PLAY_AGAIN_SAME_SETTINGS = "PLAY_AGAIN_SAME_SETTINGS";

export const RESET_GAME_SETTINGS = "RESET_GAME_SETTINGS";

export const SHOW_TRICK_CARD_WINNER = "SHOW_TRICK_CARD_WINNER";
